var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"loginTop"},[_c('loginTop')],1),_c('div',{staticClass:"header"},[_c('headerSearch')],1),_c('div',{staticClass:"content_app_box scroll"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }